import React from 'react'
import { gql } from '@apollo/client'
import { ChildDataProps, graphql } from '@apollo/client/react/hoc'

import { Overlay, RatingHeaderProps } from 'suf_storybook'

import { compose } from '../lib'
import hasRuntimeQuery from './hocs/hasRuntimeQuery'
import hasLoading from './hocs/hasLoading'

export type MarketoOverlayProps = {
  handleCloseClick: () => void
  isOpen: boolean
  isRAC: boolean
  marketoFormId: string
  slug: string
}

type Response = { getSFResearchItem: RatingHeaderProps }
type Variables = { slug: string }
type ChildProps = ChildDataProps<MarketoOverlayProps, Response, Variables>

const hasRAC = graphql<MarketoOverlayProps, Response, Variables, ChildProps>(
  gql`
    query RAC($slug: String!) {
      getSFResearchItem(slug: $slug) {
        dbDocId
        marketing {
          contentAccessType {
            name
            slug
          }
        }
      }
    }
  `,
  {
    options: ({ slug }) => ({
      variables: { slug }
    })
  }
)

const wrapper = ({
  data: { getSFResearchItem },
  handleCloseClick,
  isOpen,
  isRAC,
  marketoFormId,
  slug
}: ChildProps) => {
  if (getSFResearchItem === null && isRAC) {
    window.location.replace(`/404.html?slug=${slug}`)
  }
  return (
    <Overlay isOpen={isOpen} className="overlay-content-wrapper active">
      <span
        className="overlay__close"
        role="presentation"
        onClick={handleCloseClick}
        onKeyUp={handleCloseClick}
      >
        <i className="fas fa-times" />
      </span>

      <div className="overlay__header">
        <div
          className="heading--2"
          style={{ color: 'var(--inverted-text-color)' }}
        >
          Download Now
        </div>
      </div>

      <div className="overlay__content form-form">
        <form id={`mktoForm_${marketoFormId}`} />
      </div>

      <div
        className="overlay__content form-thankyou"
        style={{ display: 'none' }}
      >
        <div className="block-content">
          <p>Thank you. Your download link will be emailed to you shortly.</p>
        </div>
      </div>
    </Overlay>
  )
}

export default compose([hasRuntimeQuery, hasRAC, hasLoading])(wrapper)
